import React, { useMemo } from 'react';
import { getLogoUrl } from '../../helpers';

export interface ILogoProps {
  maxWidth: number;
  maxHeight: number;
}

export const Logo: React.FC<ILogoProps> = ({ maxWidth, maxHeight }) => {
  // getLogoUrl reads + parses localStorage — memoize so the read happens once
  // per mount rather than every render.
  const logoUrl = useMemo(() => getLogoUrl(), []);

  return (
    <img
      src={logoUrl}
      alt="Shop logo"
      style={{ maxWidth: `${maxWidth}px`, maxHeight: `${maxHeight}px`, height: `${maxHeight}px` }}
    />
  );
};
